module.exports = __webpack_public_path__ + "img/distinguishedsociety-white.7f4a8a4e.svg";